import React, {useState} from "react";
import Checkbox from 'expo-checkbox';
import { StyleSheet, Text, View, Button, TextInput, ImageBackground,Image,Dimensions,TouchableOpacity, Alert} from "react-native";
import imgSrc2 from './images/test19.jpg';
import imgSrc1 from './images/submit.jpg';
import logo from './images/clemgram_black.jpg';

//<ImageBackground source={imgSrc} resizeMode="cover" style={styles.image}>

import { initializeApp } from "firebase/app";
import { getDatabase, ref, set,update } from "firebase/database";
//<ImageBackground source={imgSrc} resizeMode="cover" style={styles.image}>

// TODO: Replace the following with your app's Firebase project configuration
// See: https://firebase.google.com/docs/web/learn-more#config-object
const firebaseConfig = {
    // ...
    apiKey: "AIzaSyB3kIHJz7Ey5FXzUVsN5Gfjp8tBaG6xYbw",
      authDomain: "stress-and-privacy.firebaseapp.com",
    databaseURL: "https://stress-and-privacy-default-rtdb.firebaseio.com",
      projectId: "stress-and-privacy",
      storageBucket: "stress-and-privacy.appspot.com",
      messagingSenderId: "738098786959",
      appId: "1:738098786959:web:a6469cc294345688a476fa" 
  };
  
  // Initialize Firebase
  const app = initializeApp(firebaseConfig);
  
  
  // Initialize Realtime Database and get a reference to the service
  const database = getDatabase(app);

const Info = (props) => {
	const [firstname,setFirstname]=useState(props.navigation.state.params.firstname);
	const [lastname,setLastname]=useState(props.navigation.state.params.lastname);
	const [email,setEmail]=useState(props.navigation.state.params.email);
	const [bio,setBio]=useState(props.navigation.state.params.bio);
	const [ppic,setPpic]=useState(props.navigation.state.params.pic);
	const [password,setPassword]=useState('');
	const [pid,setPid]=useState('');
	const [isChecked, setChecked] = useState(false);
	
return( 
		           
	<View style={styles.container}>
			<View style={{flexDirection:"row",alignItems:'left',justifyContent:'left',textAlign:'left'}}>
			<Image         
					style={styles.ichart}
					resizeMode={'center'}
					source={logo}/>
			<Text style={styles.text22}>Clemgram</Text>
			</View>
		<Text style={styles.text}></Text>
			
		<Text style={styles.text2}>Create your account</Text>

		<ImageBackground source={imgSrc2}  resizeMode='cover' style={styles.image}>
		<View style={{flexDirection:"column",marginTop: 20,marginBottom: 20,alignItems:'center',justifyContent:'center',textAlign:'center'}}></View>

		<View style={styles.textAreaContainer} >
		<TextInput
					style={styles.textArea}
					onChangeText={(name) => setFirstname(name)}
					placeholder="First name"
					placeholderTextColor="black"
					value={firstname}/>
			
    	<TextInput
					style={styles.textArea}
					onChangeText={(val) => setLastname(val)}
					placeholder="Last name"
					placeholderTextColor="black"
					value={lastname}/>
		<TextInput
					style={styles.textArea}
					onChangeText={(nam) => setEmail(nam)}
					placeholder="Enter your Email"
					placeholderTextColor="black"
					value={email}/>
		<TextInput
					style={styles.textArea}
					onChangeText={(niam) => setPid(niam)}
					placeholder="Enter your Id"
					placeholderTextColor="black"
					value={pid}/>
		<TextInput
					style={styles.textArea}
					onChangeText={(nap) => setPassword(nap)}
					placeholder="Password"
					secureTextEntry={true}
					placeholderTextColor="black"
					value={password}/>
 </View>
 <View style={styles.section}>
        <Checkbox style={styles.checkbox} value={isChecked} onValueChange={setChecked} />
        <Text style={styles.paragraph} onPress={() => props.navigation.navigate('Terms')}
		>  Agree to Terms of service </Text>
      </View>
		<TouchableOpacity style={{flexDirection:"row",alignItems:'center',justifyContent:'center',marginTop:Dimensions.get('window').height/13}}
		 onPress={() => {
			if(isChecked)
            {
				
				var res = email.split("@");
				//alert(res[0]);
				set(ref(database, 'users/' + res[0]), {
					firstname: firstname,
					lastname: lastname,
					pid:pid,
					email: email,
				  });
		
				props.navigation.navigate('Main',{firstname: firstname,lastname: lastname,email: res[0],pic:'default',bio:bio});
            }
            else{
               alert('Please agree to Terms of service!');
            }
			
			}}>
			
			<Image         
				style={styles.ichart}
				resizeMode={'center'}
				source={imgSrc1}/>
		</TouchableOpacity>

		</ImageBackground>
	</View>

)
	
}
//<Text style={styles.text3}>   You will write each post using our tool. </Text>
                
const styles = StyleSheet.create({
	container: {
		padding: 5,
		flex: 1,
		display: "flex",
		marginTop: 5,
		textAlign: 'center',
		flexDirection: "column",
		justifyContent: "center",
		backgroundColor:"black",
	},
	section: {
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: "center",
		textAlign: 'center',
	  },
	button: {
		alignItems: "center",
		backgroundColor: "#DDDDDD",
		padding: 10
	  },
	imageContainer: {
		padding: 1,
		marginTop: 1,
		textAlign: 'center',
        flexDirection: "row",
        paddingLeft: Dimensions.get('window').width/11,
		paddingRight: Dimensions.get('window').width/11,
		justifyContent: "center",
	},
	textContainer: {
		textAlign: 'center',
        flexDirection: "column",
		justifyContent: "center",
	},
	paragraph: {
		fontSize: 22,
		color:'white',
		fontWeight: "bold",
		textDecorationLine: 'underline',
	  },
	ichart: {
		height: Dimensions.get('window').height/15,
		width: Dimensions.get('window').width/13,
	  }, 
	buttonContainer:{
		width: '15%',
		alignSelf: 'center',
		marginTop: 80,
	},
	iweb2: {
		height: Dimensions.get('window').height/2.7,
		width: Dimensions.get('window').width/4,
		marginLeft: 1
	  },
	text: {
		
		fontSize: Dimensions.get('window').width/50,
		color:'#3a9BDC',
		marginRight: 5,
		marginLeft: 5,
	},
    text2: {
		//fontWeight: "bold",
		fontSize: 40,        
        marginBottom: 15,
		marginTop:20,        
        textAlign: 'center',
		color:'white',
	},
	text22: {
		fontSize: 40,        
        marginBottom: 15,
		fontStyle: 'italic',
		//marginTop:20,        
        textAlign: 'center',
		color:'#FFA500',
		fontFamily: "sans-serif-condensed",
	},
    text4: {
		//fontWeight: "bold",
		padding: 30,
		fontSize: 18,
	},
	image: {
		flex: 1,
		justifyContent: "center"
	  },
	buttonStyle: {
	alignItems: 'center',
	justifyContent: 'center',
	paddingVertical: 52,
	paddingHorizontal: 32,
	paddingTop: 20,
	borderRadius: 1,
	borderWidth:10,
	elevation: 13,
	backgroundColor:"#341ada"
	},
	listContainer: {
		paddingTop: 20
	},
	listItem: {
		fontSize: 20
	},
	text3: {
		marginTop: 20,        
        marginBottom: 20,        
        textAlign: 'center',
		fontSize: Dimensions.get('window').width/70,
		color:'#03C04A',
		marginRight: Dimensions.get('window').width/5,
		marginLeft: Dimensions.get('window').width/5,
		
	},
	  textAreaContainer: {
		
		paddingTop: 30,
		paddingRight:Dimensions.get('window').width/2.5,
		paddingLeft: Dimensions.get('window').width/2.5,
		paddingBottom: 30,
		textAlign: 'center',

	  },
	  textArea: {
		height: 50,
		width:290,
		fontSize: 16,
		borderColor: 'white',
		backgroundColor:'white',
		color:'black',
		borderWidth: 2,
		borderColor:'black',
		marginBottom: 20,
		justifyContent: "center"
	  },
	  checkboxContainer: {
		flexDirection: "row",
		
	  },
	  checkbox: {
		alignSelf: "center",
	  },
})
export default Info